<p-tabView [(activeIndex)]="activeIndex">
  @for (tab of tabs(); track tab; let index = $index) {
    <p-tabPanel>
      <ng-template pTemplate="header">
        {{ tab.header() ?? index.toString() }}
        @if(tab?.showActive()){
          <span class="showActive"></span>
        }
      </ng-template>
      <ng-template [ngTemplateOutlet]="tab.template"></ng-template>
    </p-tabPanel>
  }
</p-tabView>
